export const countryCodeMap: { [key: string]: string } = {
  DE: 'DEU',
  NO: 'NOR',
  CA: 'CAN',
  ES: 'ESP',
  IT: 'ITA',
  GB: 'GBR',
  PL: 'POL',
  IN: 'IND',
  GR: 'GRC',
  FR: 'FRA',
  US: 'USA',
  ME: 'MNE',
  NL: 'NLD',
  IE: 'IRL',
  DK: 'DNK',
  SE: 'SWE',
  BE: 'BEL',
  FI: 'FIN',
  LU: 'LUX',
  CH: 'CHE',
  AU: 'AUS',
  SG: 'SGP',
  TR: 'TUR',
  AR: 'ARG',
  BR: 'BRA',
  KR: 'KOR',
  JP: 'JPN',
  TW: 'TWN',
  ZA: 'ZAF',
  MX: 'MEX',
  AZ: 'AZE',
  BH: 'BHR',
  DU: 'DZA',
  SA: 'SAU',
  KW: 'KWT',
  OM: 'OMN',
  QA: 'QAT',
  JO: 'JOR',
  LB: 'LBN',
};
